module.exports = "./img/desktop_logo.995167c.png";